<template>
  <section class="choose-taste-product">

    <div class="choose-taste-product__container">
      <slot v-if="!buttonClick" name="content" :buttonClick="buttonClick" :buttonLikeClick="buttonLikeClick" :sumClick="sumClick" :clickCurrent="clickCurrent" :clickUp="clickUp"></slot>

      <div v-if="buttonClick" class="choose-taste-product__content ">

        <div class="choose-taste-product__info">

          <a class="choose-taste-product__link-back choose-taste-product__link-back_desktop " :href="linkinsection">
            <svg class="i-arrow" aria-hidden="true">
              <use xlink:href="./icons/icons.svg#svg-arrow"></use>
            </svg>Назад</a>
          <div class="choose-taste-product__headings ">
            <h1 class="choose-taste-product__title title title_h1"> {{clickproduct.PROPERTIES.NAME_EN.VALUE}}</h1>

            <div class="choose-taste-product__subtitle title title_h4">{{clickproduct.PROPERTIES.SMALL_DESCRIPTION.VALUE}}</div>
          </div>
          <div class="choose-taste-product__tabs ">
            <nav class="choose-taste-product__nav" data-tabs="choose-taste-product__tabs-content">
              <button class="choose-taste-product__tab-title btn btn_white active">Описание</button>
              <button class="choose-taste-product__tab-title btn btn_white">Ингредиенты</button>
              <button class="choose-taste-product__tab-title btn btn_white">Аллергии</button>
            </nav>
            <div class="choose-taste-product__tabs-content ">
              <div class="choose-taste-product__tab-content active">
                <p class="choose-taste-product__paragraph" v-html="clickproduct.PROPERTIES.FULL_DESCRIPTION.VALUE"></p>

              </div>
              <div class="choose-taste-product__tab-content">
                <p class="choose-taste-product__paragraph" v-html="clickproduct.PROPERTIES.INGREDIENTS.VALUE"></p>
              </div>
              <div class="choose-taste-product__tab-content">
                <p class="choose-taste-product__paragraph" v-html="clickproduct.PROPERTIES.ALLERGIES.VALUE"></p>
                 </div>
            </div>
          </div>
          <div class="choose-taste-product__price title title_h2 ">{{clickproduct.PROPERTIES.PRICE.VALUE}}</div>
          <button class="choose-taste-product__link link-taste-more" data-popup="#wholesale" href="#">
            <svg class="i-btn-bg" aria-hidden="true">
              <use xlink:href="./icons/icons.svg#svg-btn-bg"></use>
            </svg>
            <div class="link-taste-more__wrapper">
              <svg class="i-arrow-curved" aria-hidden="true">
                <use xlink:href="./icons/icons.svg#svg-arrow-curved"></use>
              </svg>
              <div>Заказать оптом</div>
            </div></button>
        </div>
        <div class="choose-taste-product__background" :style="clickproduct.PROPERTIES.COLOR.VALUE">
          <svg class="i-choose-taste-product-bg" aria-hidden="true">
            <use xlink:href="./icons/icons.svg#svg-choose-taste-product-bg"></use>
          </svg>
        </div>
        <div class="choose-taste-product__images">
          <div class="choose-taste-product__packing">
            <picture>
              <img :src="clickproduct.PROPERTIES.PRODUCT_IMAGE.SRC" alt="alt">
            </picture>
          </div>
          <div class="choose-taste-product__large">
            <picture>
              <img :src="clickproduct.PROPERTIES.TASTE_IMAGE.SRC" alt="alt">
            </picture>
          </div>
          <div class="choose-taste-product__like">

            <button @click.once = "clickCurrent(clickproduct.PROPERTIES.SUM_CLICK.VALUE), like()" @click="clickUp(clickproduct.ID)"  class="choose-taste-product__like-svg">
              <svg class="i-heart" aria-hidden="true">
                <use xlink:href="./icons/icons.svg#svg-heart"></use>
              </svg>
            </button>
            <div v-if="!buttonLikeClick" >{{ clickproduct.PROPERTIES.SUM_CLICK.VALUE }}</div>
            <div v-else>{{ sumClick }}</div>
          </div>
        </div>

      </div>

      <div class="choose-taste-product__tastes fadeInLeft">
        <span style="cursor: pointer" @click="switchProd(product.CODE, product.ID), InitUI(product.CODE), updateUrl(product.DETAIL_PAGE_URL)" v-for="(product, index) in products" :class="[product.CODE === clickproduct.CODE ? 'active' : '' ,'choose-taste-product__taste']" :key="index" :style="product.PROPERTIES.COLOR.VALUE" >
        <div  class="choose-taste-product__taste-img">
          <svg class="i-taste-bg" aria-hidden="true">
            <use xlink:href="./icons/icons.svg#svg-taste-bg"></use>
          </svg>
          <picture>
           <img :src="product.PROPERTIES.ICON.SRC" alt="alt">
          </picture>
        </div>
        <div class="choose-taste-product__taste-title">{{ product.NAME }}</div>
        </span>

      </div>
      <a class="choose-taste-product__link-back choose-taste-product__link-back_mobile fadeInRight" :href="linkinsection">
        <svg class="i-arrow" aria-hidden="true">
          <use xlink:href="./icons/icons.svg#svg-arrow"></use>
        </svg>Назад</a>
    </div>
  </section>
  <section class="advantages">
    <slot v-if="!buttonClick" name="advantages" :colorAdvantages="colorAdvantages"></slot>
    <div v-if="buttonClick" class="advantages__container">
      <h2 class="advantages__title title title_h1">преимущества для вас</h2>
      <ul class="advantages__rows">
        <li class="advantages__row">
          <ul class="advantages__columns">
            <li v-for="(advantage, index) in clickproduct.PROPERTIES.ADVANTAGES.VALUE" :key="index" class="advantages__column">
              <div class="advantages__decor">
                <svg class="i-coffee" aria-hidden="true" :style="colorAdvantages[index]">
                  <use xlink:href="./icons/icons.svg#svg-coffee"></use>
                </svg>
              </div>
              <div class="advantages__column-wrapper">{{ advantage }}</div>

            </li>
          </ul>
        </li>
      </ul>
    </div>
  </section>
  <section class="food-value bubble-section">
    <div class="bubble-section__decor fadeIn">
      <svg class="i-bubble-decor" aria-hidden="true">
        <use xlink:href="./icons/icons.svg#svg-bubble-decor"></use>
      </svg>
      <svg class="i-leaf" aria-hidden="true">
        <use xlink:href="./icons/icons.svg#svg-leaf"></use>
      </svg>
    </div>
    <slot v-if="!buttonClick" name="bubble"></slot>
    <div v-if="buttonClick" class="bubble-section__container">
      <h2 class="bubble-section__title title title_h1 ">Пищевая ценность</h2>
      <h3 class="bubble-section__subtitle title title_h4 ">Пищевая ценность в 100 мл</h3>
      <div class="bubble-section__table ingredients-table ">
        <div v-for="(valueFood, index) in clickproduct.PROPERTIES.FOOD_VALUE.VALUE" :key="index" class="ingredients-table__row">
          <div class="ingredients-table__label">{{ clickproduct.PROPERTIES.FOOD_VALUE.DESCRIPTION[index] }}</div>
          <div class="ingredients-table__value">{{ valueFood }}</div>
        </div>
      </div>
    </div>
  </section>
  <section v-if="clickproduct.PROPERTIES.RECIPES" class="recipes-product">
    <slot v-if="!buttonClick" name="recipes"></slot>
    <div v-if="buttonClick" class="recipes-product__container">
      <div class="recipes-product__info recipes-product__info_barista recipes-product__info_gm ">
        <h2 class="recipes-product__title title title_h2">Рецепты с растительным молоком Green Milk {{ clickproduct.NAME }}</h2>
      </div>

      <div class="recipes-product__cards ">
        <a class="recipes-product__link link-taste-more " href="/recipes/">
        <svg class="i-btn-bg" aria-hidden="true">
          <use xlink:href="./icons/icons.svg#svg-btn-bg"></use>
        </svg>
        <div class="link-taste-more__wrapper">
          <svg class="i-arrow-curved" aria-hidden="true">
            <use xlink:href="./icons/icons.svg#svg-arrow-curved"></use>
          </svg>
          <div>Все рецепты</div>
        </div></a>
        <article v-for="(recipe, index) in clickproduct.PROPERTIES.RECIPES" :key="index" class="recipes-product__card recipes-card">
          <div class="recipes-card__info">
            <div class="recipes-card__tag">{{recipe.SECTION.NAME}}</div>
            <a class="recipes-card__title" :href="recipe.URL">
            {{ recipe.NAME }}
          </a>
          </div>
          <div class="recipes-card__image">
            <picture>
              <img :src="recipe.PIC.src">
            </picture>
          </div>
        </article>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name : "CollectionDetail",

  data() {
    return {
      checkcode: null,
      colorAdvantages: [
          'color:#98D5FF;',
          'color:#B6A085;',
          'color:#FFC700;',
          'color:#79D47B;',
          'color:#EEA9DC;',
          'color:#86AEEA;',
          'color:#98D5FF;',
          'color:#B6A085;',
          'color:#FFC700;',
          'color:#79D47B;',
          'color:#EEA9DC;',
          'color:#86AEEA;',
          'color:#98D5FF;',
          'color:#B6A085;',
          'color:#FFC700;',
          'color:#79D47B;',
          'color:#EEA9DC;',
          'color:#86AEEA;',
      ],
      sumClick: 0,
      buttonClick: false,
      buttonLikeClick: false,
      idProd: 0,
      sessionClick: 0
    }
  },

  props: {
    products: {
      type: Object,
      required: true
    },

    checkproduct: {
      type: Object,
      required : true
    },
    linkinsection: {
      type: String,
      required : true
    }
  },

  computed: {
    clickproduct() {
      if(this.checkcode === null) {
        return this.checkproduct;
      }
      else {
        return this.products[this.checkcode];
      }

    }
  },


  mounted()
    {
      document.querySelector('.breadcrumbs').classList.add('breadcrumbs_product');
      document.querySelector('.page').classList.remove('page_collection-tastes');
      document.querySelector('.page').classList.add('page_product');

    },
  methods: {

    updateUrl(url)
      {
        if( history.pushState )
          {
            let baseUrl=window.location.protocol + "//" + window.location.host;
            let newUrl =baseUrl + url;
            history.pushState(null, null, newUrl);
          }
      },

    InitUI(code)
      {


        if( this.checkcode !== code )
          {
            setTimeout(() =>
            {
              window.animationChooseTasteProduct().play();
            }, 1000)

            setTimeout(() =>
            {
              window.animationChooseTasteProduct().reverse(0);
            }, 0)

          }

      },
    clickUp(id = null)
      {
        if(this.sessionClick <= 100){
          // window.like();
          this.sessionClick += 1;
          this.idProd = Number(id);
          this.buttonLikeClick = true;
          this.sumClick += 1;
          const formData = new FormData();
          formData.set('click', this.sumClick);
          formData.set('id', this.idProd);
          fetch("/local/api/requestHandler.php",{
            method : "POST",
            //headers: {
            //'Content-Type': 'application/json'
            //},
            //body   : JSON.stringify(this.formData)
            body: formData
          })
              .then(response => response.json())
              .then(result =>
              {
                if(result.clickAdded) {
                  //this.sumClick += 1;
                }
              })
        }

      },
    clickCurrent(likesValue = null)
      {
        this.sumClick = Number(likesValue);
      },
    like()
      {
        window.initHeartClicker();
      },
    switchProd(code, id)
      {
        if( this.checkcode !== code )
          {
            setTimeout(() =>
                {
                  this.buttonClick=true;
                  this.checkcode  =code;
                  setTimeout(() => {
                    window.tabs();
                    window.popup();
                  }, 1100)
                }, 1000
            )
            const formData=new FormData();
            formData.set('get_sum_click', id);

            fetch("/local/api/requestHandler.php", {
              method : "POST",
              //headers: {
              //'Content-Type': 'application/json'
              //},
              //body   : JSON.stringify(this.formData)
              body : formData
            })
                .then(response => response.json())
                .then(result =>
                {
                  if( result.sumClickProd )
                    {
                      this.sumClick=Number(result.sumClickProd);
                    }
                })

          }
      }
  }
};
</script>

<style scoped>

</style>